import { Grid, Typography } from '@mui/material';
import { format } from 'date-fns';
import React from 'react';
import { PriorityItemDto } from '../../api';
import Collapsible from '../../components/Collapsible';

const PriorityHistory = (props: { priority: PriorityItemDto }) => {
  const { priority } = props;

  return (
    <Collapsible title="Priority History">
      <Grid container textAlign="center" justifyItems={'space-between'}>
        <Grid container>
          <Grid item xs={2} zeroMinWidth>
            <Typography fontWeight="bold" variant="body1">
              Action
            </Typography>
          </Grid>
          <Grid item xs={6} zeroMinWidth>
            <Typography fontWeight="bold" variant="body1">
              Actioned By
            </Typography>
          </Grid>
          <Grid item xs={4} zeroMinWidth>
            <Typography fontWeight="bold" variant="body1">
              Actioned At
            </Typography>
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={2} zeroMinWidth>
            <Typography variant="body1">Created</Typography>
          </Grid>

          <Grid item xs={6} zeroMinWidth>
            <Typography style={{ overflowWrap: 'break-word' }} variant="body1">
              {priority?.createdBy}
            </Typography>
          </Grid>

          <Grid item xs={4} zeroMinWidth>
            <Typography variant="body1">{format(new Date(priority?.createdAt!), 'dd/MM/yyyy hh:mm a')}</Typography>
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={2} zeroMinWidth>
            <Typography variant="body1">Updated</Typography>
          </Grid>

          <Grid item xs={6} zeroMinWidth>
            <Typography style={{ overflowWrap: 'break-word' }} variant="body1">
              {priority?.updatedBy}
            </Typography>
          </Grid>

          <Grid item xs={4} zeroMinWidth>
            <Typography variant="body1">{format(new Date(priority?.updatedAt!), 'dd/MM/yyyy hh:mm a')}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Collapsible>
  );
};

export default PriorityHistory;
